export enum ESeverity {
  CRITICAL = 'CRITICAL',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  LOW = 'LOW',
  NA = 'NA',
}
